<style>
@import '../../custom/css/respondidas.css';
</style>

<template>
  <div class="respondidas">
    <div class="row m-0">
      <div class="col-12" v-if="cotacoes !== [] && cotacoes.length !== 0">
        <h1 class="title font-weight-bold text-uppercase" id="inicio">
          Orçamentos Respondidos
        </h1>
        <hr class="linha-amarela" />
      </div>
      <div class="col-12" v-else>
        <h1 class="title font-weight-bold text-uppercase" id="inicio">
          Sem Orçamentos Respondidos
        </h1>
        <hr class="linha-amarela" />
      </div>
      <div class="col-12" v-for="(dados, index) in cotacoes" :key="index">
        <h3 class="title font-weight-bold text-uppercase mt-3">
          Orçamento {{ dados.cotacoes[0].nome_cotacao || 'Nº ' + dados.numero }}
        </h3>
        <div class="row m-0" v-if="!checkIsEmpty(dados.cotacoes)">
          <div
            class="col-lg-4 col-md-6 col-sm-12 col-12"
            v-for="(cotacao, index) in dados.cotacoes"
            :key="index"
          >
            <div
              :class="
                cotacao.cotacaoVista === true
                  ? 'card-cotacao cotacao-cinza'
                  : 'card-cotacao cotacao-amarelo'
              "
            >
              <div class="cc-header d-flex">
                <div class="cc-sub-title m-r-25">
                  <img
                    class="imagem-archive-cotacao"
                    src="@/assets/img/icons/file-archive.png"
                    alt="Ícone para representar a cotação"
                  />
                </div>
                <div class="cc-sub-title">
                  <div>
                    Data:
                    <div class="cc-sub-result">{{ cotacao.atualizado_em }}</div>
                  </div>
                  <div v-if="!cotacao.nome_cotacao">
                    Cód:
                    <div class="cc-sub-result">
                      {{ cotacao.cot_cotacao_id }}-{{ index + 1 }}
                    </div>
                  </div>
                  <div v-else>
                    Nome:
                    <div class="cc-sub-result">
                      {{ cotacao.nome_cotacao }}-{{ index + 1 }}
                    </div>
                  </div>
                  <div v-if="cotacao.cot_usuario_enviador_dados.dadosLojista">
                    Cidade:
                    <div class="cc-sub-result">
                      {{
                        cotacao.cot_usuario_enviador_dados.dadosLojista.cidade
                          .nome
                      }}
                    </div>

                    <div class="cc-sub-result">
                      <PaymentForm
                        :idQuote="cotacao.id"
                        :origin="out"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="cc-footer">
                <div
                  class="btn-ver-cotacao"
                  @click="verCotacao(cotacao.id, index + 1)"
                >
                  Ver Orçamento
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import makeToast from '../../mixins/makeToast';
import PaymentForm from '../../components/PaymentForm.vue';

export default {
  name: 'respondidas',
  mixins: [makeToast],
  components: {
    PaymentForm,
  },
  computed: {
    ...mapState({
      token: (state) => state.token,
      dadosUsuario: (state) => state.dadosUsuario,
      cotacoes: (state) => state.cotacoes,
    }),
  },
  created() {
    setTimeout(this.scrollToElement, 700);
    if (this.checkIsEmpty(this.dadosUsuario)) {
      this.$router.push({ name: 'area-restrita' });
    }

    this.$store.dispatch('startLoader');
    this.$store.dispatch('emptyCotacoes').then(() => {
      this.$store
        .dispatch('showCotacoesUsuarioRespondidasV2', this.dadosUsuario.id)
        .catch(() => {
          this.makeToast(
            'Oopss!',
            'Não foi possível carregar as cotações! Tente novamente em 5 minutos!',
            'danger'
          );
        })
        .finally(() => {
          setTimeout(() => {
            this.$store.dispatch('endLoader');
          }, 1000);
        });
    });
  },
  mounted() {
    setTimeout(this.scrollToElement, 700);
  },
  methods: {
    ...mapActions('quote', ['extractAnsweredQuotesIds']),
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    verCotacao(quoteId, quoteIdentifier) {
      if (!this.checkIsEmpty(quoteId)) {
        this.extractAnsweredQuotesIds(this.cotacoes);
        this.$router.push({
          name: 'cliente-cotacao-respondida',
          params: { id: quoteId, identifier: quoteIdentifier },
        });
      }
    },
    scrollToElement() {
      let windowWidth = window.innerWidth;
      if (windowWidth <= 768) {
        let element = document.getElementById('inicio');
        element.scrollIntoView();
      }
    },
  },
};
</script>
